import { Enum, _void, Vector, Struct, str, u8, Option } from 'scale-ts';
import '../../utils/ss58-util.mjs';
import '../scale/Binary.mjs';
import '../scale/bitSequence.mjs';
import '../scale/char.mjs';
import { compactNumber } from '../scale/compact.mjs';
import { Hex } from '../scale/Hex.mjs';
import '../scale/fixed-str.mjs';
import '../scale/Variant.mjs';
import '../scale/ethAccount.mjs';
import { docs } from './docs.mjs';

const hashType = Enum({
  Blake2128: _void,
  Blake2256: _void,
  Blake2128Concat: _void,
  Twox128: _void,
  Twox256: _void,
  Twox64Concat: _void,
  Identity: _void
});
const hashers = Vector(hashType);
const storageMap = Struct({
  hashers,
  key: compactNumber,
  value: compactNumber
});
const storageItem = Struct({
  name: str,
  modifier: u8,
  type: Enum({
    plain: compactNumber,
    map: storageMap
  }),
  fallback: Hex(),
  docs
});
const storage = Option(
  Struct({
    prefix: str,
    items: Vector(storageItem)
  })
);
const v14Pallet = {
  name: str,
  storage,
  calls: Option(compactNumber),
  events: Option(compactNumber),
  constants: Vector(
    Struct({
      name: str,
      type: compactNumber,
      value: Hex(),
      docs
    })
  ),
  errors: Option(compactNumber),
  index: u8
};
const v15Pallet = {
  ...v14Pallet,
  docs
};

export { v14Pallet, v15Pallet };
//# sourceMappingURL=pallets.mjs.map
